import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import CheckListItem from '../editor/editor-component/check-list-item';
import Formula from '../viewer/viewer-formula';
import { ViewerImage } from '../viewer/viewer-image';

function renderNode(_ref) {
  var attributes = _ref.attributes,
      children = _ref.children,
      element = _ref.element;
  var node = element;
  var data = node.data ? node.data : {};
  var checked = data.checked;
  var align = data.align;
  var href = data.href;
  var diffClass = data.diff_state;
  var diffIndex = data.new_index;
  align = ['left', 'right', 'center'].indexOf(align) === -1 ? 'left' : align;

  switch (node.type) {
    case 'paragraph':
      return /*#__PURE__*/React.createElement("p", Object.assign({
        className: diffClass ? diffClass + ' ' + (data['paragraph_state'] ? data['paragraph_state'] : '') : ''
      }, attributes), children);

    case 'blockquote':
      return /*#__PURE__*/React.createElement("blockquote", attributes, children);

    case 'header_one':
      return /*#__PURE__*/React.createElement("h1", Object.assign({}, attributes, {
        id: 'user-content-' + node.children[0].text
      }), children);

    case 'header_two':
      return /*#__PURE__*/React.createElement("h2", Object.assign({}, attributes, {
        id: 'user-content-' + node.children[0].text
      }), children);

    case 'header_three':
      return /*#__PURE__*/React.createElement("h3", Object.assign({}, attributes, {
        id: 'user-content-' + node.children[0].text
      }), children);

    case 'header_four':
      return /*#__PURE__*/React.createElement("h4", attributes, children);

    case 'header_five':
      return /*#__PURE__*/React.createElement("h5", attributes, children);

    case 'header_six':
      return /*#__PURE__*/React.createElement("h6", attributes, children);

    case 'list_item':
      if (checked === undefined) return /*#__PURE__*/React.createElement("li", Object.assign({
        value: diffIndex ? diffIndex >= 0 ? diffIndex + 1 : data['old_index'] + 1 : '',
        className: diffClass ? diffClass : ''
      }, attributes), children);
      return /*#__PURE__*/React.createElement(CheckListItem, {
        className: diffClass ? diffClass : '',
        attributes: attributes,
        children: children,
        element: element
      });

    case 'unordered_list':
      return /*#__PURE__*/React.createElement("ul", Object.assign({
        className: diffClass ? diffClass : ''
      }, attributes), children);

    case 'ordered_list':
      return /*#__PURE__*/React.createElement("ol", Object.assign({
        className: diffClass ? diffClass : ''
      }, attributes), children);

    case 'image':
      return /*#__PURE__*/React.createElement(ViewerImage, {
        attributes: attributes,
        children: children,
        node: node
      });

    case 'code_block':
      return /*#__PURE__*/React.createElement("pre", {
        className: 'code-container'
      }, /*#__PURE__*/React.createElement("code", Object.assign({
        className: 'code'
      }, attributes), children), /*#__PURE__*/React.createElement(LanguageSet, {
        disabled: true,
        lang: node.data.syntax
      }));

    case 'code_line':
      return /*#__PURE__*/React.createElement("p", attributes, children);

    case 'table':
      return /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", attributes, children));

    case 'table_row':
      return /*#__PURE__*/React.createElement("tr", Object.assign({
        className: diffClass ? diffClass : ''
      }, attributes), children);

    case 'table_cell':
      return /*#__PURE__*/React.createElement("td", Object.assign({
        className: diffClass ? diffClass : '',
        style: {
          textAlign: align
        }
      }, attributes), children);

    case 'link':
      return /*#__PURE__*/React.createElement("a", Object.assign({
        className: diffClass ? diffClass : ''
      }, attributes, {
        href: href
      }), children);

    case 'hr':
      return /*#__PURE__*/React.createElement("hr", attributes);

    case 'formula':
      return /*#__PURE__*/React.createElement(Formula, Object.assign({
        className: diffClass ? diffClass : '',
        node: node,
        children: children
      }, attributes));

    default:
      return /*#__PURE__*/React.createElement("p", attributes, children);
  }
}

var renderLeaf = function renderLeaf(_ref2) {
  var attributes = _ref2.attributes,
      children = _ref2.children,
      leaf = _ref2.leaf;

  if (leaf.BOLD) {
    children = /*#__PURE__*/React.createElement("strong", null, children);
  }

  if (leaf.CODE) {
    children = /*#__PURE__*/React.createElement("code", null, children);
  }

  if (leaf.ITALIC) {
    children = /*#__PURE__*/React.createElement("i", null, children);
  }

  if (leaf.DELETE) {
    children = /*#__PURE__*/React.createElement("del", null, children);
  }

  if (leaf.ADD) {
    children = /*#__PURE__*/React.createElement("ins", null, children);
  }

  if (leaf.decoration) {
    return /*#__PURE__*/React.createElement("span", {
      className: "token ".concat(leaf.type)
    }, children);
  }

  return /*#__PURE__*/React.createElement("span", attributes, children);
};

var LanguageSet = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(LanguageSet, _React$PureComponent);

  var _super = _createSuper(LanguageSet);

  function LanguageSet() {
    _classCallCheck(this, LanguageSet);

    return _super.apply(this, arguments);
  }

  _createClass(LanguageSet, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "language-type"
      }, /*#__PURE__*/React.createElement("select", {
        value: this.props.lang,
        disabled: true,
        name: "language"
      }, /*#__PURE__*/React.createElement("option", {
        value: "none"
      }, "Text"), /*#__PURE__*/React.createElement("option", {
        value: "html"
      }, "HTML"), /*#__PURE__*/React.createElement("option", {
        value: "css"
      }, "CSS"), /*#__PURE__*/React.createElement("option", {
        value: "javascript"
      }, "Javascript"), /*#__PURE__*/React.createElement("option", {
        value: "c"
      }, "C"), /*#__PURE__*/React.createElement("option", {
        value: "cpp"
      }, "C++"), /*#__PURE__*/React.createElement("option", {
        value: "csharp"
      }, "C#"), /*#__PURE__*/React.createElement("option", {
        value: "java"
      }, "Java"), /*#__PURE__*/React.createElement("option", {
        value: "python"
      }, "Python"), /*#__PURE__*/React.createElement("option", {
        value: "sql"
      }, "Sql"), /*#__PURE__*/React.createElement("option", {
        value: "swift"
      }, "Swift")));
    }
  }]);

  return LanguageSet;
}(React.PureComponent);

export { renderNode, renderLeaf };